import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useOrder } from '../context/OrderContext';
import Swal from 'sweetalert2';

const Header = ({
    showBack = true,
    backText,
    backTo,
    onBack,
    actions,
    transparent = false,
    className = ''
}) => {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const { state } = useOrder();
    const [adminMenuOpen, setAdminMenuOpen] = useState(false);

    const isAdmin = user?.role === 'admin';
    const cartItems = state?.cartItems || [];

    const handleLogout = async () => {
        const result = await Swal.fire({
            title: 'Conferma Logout',
            text: 'Sei sicuro di voler uscire?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sì, esci',
            cancelButtonText: 'Annulla',
            confirmButtonColor: '#cd212a',
            cancelButtonColor: '#6b7280'
        });

        if (result.isConfirmed) {
            logout();
            navigate('/login');
        }
    };

    const handleBack = async () => {
        // Check if there are items in the cart
        if (cartItems.length > 0) {
            const result = await Swal.fire({
                icon: 'warning',
                title: 'Attenzione',
                html: `Hai <strong>${cartItems.length}</strong> prodotto${cartItems.length > 1 ? 'i' : ''} nel carrello.<br><br>Sei sicuro di voler tornare alla dashboard?`,
                showCancelButton: true,
                confirmButtonText: 'Sì, torna indietro',
                cancelButtonText: 'Annulla',
                confirmButtonColor: '#cd212a',
                cancelButtonColor: '#6b7280'
            });

            if (!result.isConfirmed) {
                return; // User cancelled
            }
        }

        // Proceed with navigation
        if (onBack) {
            onBack();
        } else if (backTo) {
            navigate(backTo);
        } else {
            // Fallback to dashboard for better UX than browser back
            navigate('/dashboard');
        }
    };

    const navigateTo = (path) => {
        navigate(path);
        setAdminMenuOpen(false);
    };

    const handleLogoClick = async () => {
        const companyInfo = `Faraone Srl a socio unico
Via Po, 12 - 64018 Tortoreto (TE)

Telefono +39 0861 784200 - Partita IVA 00321830671
faraone@faraone.it - PEC faraone@pec.it - SDI: SUBM70N`;

        await Swal.fire({
            html: `
                <div class="text-left">
                    <h3 class="text-lg font-bold text-gray-800 mb-3">Faraone Srl a socio unico</h3>
                    <p class="text-gray-600 mb-2">Via Po, 12 - 64018 Tortoreto (TE)</p>
                    <div class="border-t border-gray-200 pt-3 mt-3">
                        <p class="text-gray-600 text-sm mb-1">
                            <strong>Telefono:</strong> +39 0861 784200
                        </p>
                        <p class="text-gray-600 text-sm mb-1">
                            <strong>Partita IVA:</strong> 00321830671
                        </p>
                        <p class="text-gray-600 text-sm mb-1">
                            <strong>PEC:</strong> faraone@pec.it
                        </p>
                        <p class="text-gray-600 text-sm">
                            <strong>SDI:</strong> SUBM70N
                        </p>
                    </div>
                    <div class="border-t border-gray-200 pt-3 mt-3 flex gap-2">
                        <button id="btn-website" class="flex-1 py-2 px-3 rounded-lg text-white text-sm font-medium transition-all hover:opacity-90" style="background: linear-gradient(to right, #cd212a, #a91b23);">
                            <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"></path></svg>
                            Sito Web
                        </button>
                        <button id="btn-share" class="flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-all hover:opacity-90 border-2" style="background: white; color: #cd212a; border-color: #cd212a;">
                            <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"></path></svg>
                            Condividi
                        </button>
                    </div>
                </div>
            `,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: {
                popup: 'rounded-xl'
            },
            didOpen: () => {
                document.getElementById('btn-website').addEventListener('click', () => {
                    window.open('https://www.faraone.it', '_blank');
                });
                document.getElementById('btn-share').addEventListener('click', () => {
                    Swal.close();
                    if (navigator.share) {
                        navigator.share({
                            title: 'Faraone Srl',
                            text: companyInfo
                        }).catch(() => {
                            navigator.clipboard.writeText(companyInfo);
                            Swal.fire({
                                icon: 'success',
                                title: 'Copiato!',
                                text: 'Informazioni copiate negli appunti',
                                timer: 1500,
                                showConfirmButton: false
                            });
                        });
                    } else {
                        navigator.clipboard.writeText(companyInfo);
                        Swal.fire({
                            icon: 'success',
                            title: 'Copiato!',
                            text: 'Informazioni copiate negli appunti',
                            timer: 1500,
                            showConfirmButton: false
                        });
                    }
                });
            }
        });
    };

    return (
        <header
            style={{ background: '#cd212a' }}
            className={`
        sticky top-0 z-40
        ${transparent
                    ? 'bg-transparent'
                    : 'backdrop-blur-lg border-b border-gray-200/50 shadow-sm'
                }
        transition-all duration-200
        ${className}
      `}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center">
                        {showBack && (
                            <button
                                onClick={handleBack}
                                className="
                  mr-4 px-3 py-1.5
                  rounded-lg
                  text-white
                  hover:text-white
                  hover:bg-white/20
                  transition-all
                  duration-200
                  flex items-center
                  text-sm font-medium
                  border border-white/30
                  hover:border-white/50
                  hover:shadow-sm
                "
                                title={backText ? `Torna a ${backText}` : 'Torna indietro'}
                            >
                                <svg
                                    className="w-4 h-4 mr-1.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 19l-7-7 7-7"
                                    />
                                </svg>
                                <span className="hidden sm:inline">
                                    {backText || 'Dashboard'}
                                </span>
                            </button>
                        )}

                        <img
                            src="/logo-w.png"
                            alt="Faraone"
                            className="h-8 w-auto logoX cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={handleLogoClick}
                        />
                    </div>

                    <div className="flex items-center space-x-4">
                        {actions}

                        {/* Variante attiva (solo offerte con varianti) */}
                        {state?.orderType === 'offerta' && (state?.variants || []).length > 0 && (() => {
                            const activeVariant = state.variants.find((v) => v.id === state.activeVariantId);
                            if (!activeVariant) return null;
                            return (
                                <button
                                    onClick={() => navigate('/order-summary')}
                                    className="flex items-center max-w-[120px] sm:max-w-[240px] px-3 py-1.5 rounded-lg bg-white/15 border border-white/30 text-white text-xs font-medium hover:bg-white/25 transition-colors"
                                    title="Variante in cui vengono aggiunti i nuovi articoli (clic per cambiarla nel riepilogo)"
                                >
                                    <span className="hidden sm:inline opacity-80 mr-1.5">Variante:</span>
                                    <span className="truncate font-semibold">{activeVariant.title}</span>
                                </button>
                            );
                        })()}

                        {/* Cart Button */}
                        <button
                            onClick={() => navigate('/order-summary')}
                            className="p-2 rounded-lg text-white hover:text-white hover:bg-white/20 transition-colors duration-200"
                            title="Vai al carrello"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                />
                            </svg>
                        </button>

                        {/* Admin Menu */}
                        {isAdmin && (
                            <div className="relative">
                                <button
                                    onClick={() => setAdminMenuOpen(!adminMenuOpen)}
                                    className="flex items-center px-3 py-1.5 rounded-lg text-white border border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-200 text-sm font-medium"
                                >
                                    <span>Admin</span>
                                    <svg
                                        className={`ml-1 w-4 h-4 transition-transform ${adminMenuOpen ? 'rotate-180' : ''}`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                    </svg>
                                </button>

                                {adminMenuOpen && (
                                    <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg py-1 z-50 border border-gray-200">
                                        {/* Gestione Section */}
                                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50">
                                            Gestione
                                        </div>
                                        <button
                                            onClick={() => navigateTo('/articles')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Prodotti
                                        </button>
                                        <button
                                            onClick={() => navigateTo('/clients')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Utenti/Clienti
                                        </button>
                                        <button
                                            onClick={() => navigateTo('/client-orders')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Ordini
                                        </button>

                                        {/* Statistiche Section */}
                                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50 mt-1">
                                            Statistiche
                                        </div>
                                        <button
                                            onClick={() => navigateTo('/dashboard')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Generali
                                        </button>
                                        <button
                                            onClick={() => navigateTo('/dashboard')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Personalizzate
                                        </button>

                                        {/* Configurazione Section */}
                                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50 mt-1">
                                            Configurazione
                                        </div>
                                        <button
                                            onClick={() => navigateTo('/profile')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Generale
                                        </button>
                                        <button
                                            onClick={() => navigateTo('/maintenance')}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700"
                                        >
                                            Modalità Manutenzione
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        <button
                            onClick={handleLogout}
                            className="px-3 py-1.5 rounded-lg text-white border border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-200 text-sm font-medium"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>

            {/* Gradient line */}
            <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-red-500/20 to-transparent" />
        </header>
    );
};

export default Header;
